import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsUmsService {

    constructor() { }

    public static verifyIsCnciDns() {
        return window.location.hostname.includes("universidadms");
    }

    getCurrentLogo() {
        return UtilsUmsService.verifyIsCnciDns()? "assets/img/app/logo_ums_blanco.png" : "assets/img/app/logoblanco.png";    
    }

    getCurrentCfdiImage() {
        console.log(UtilsUmsService.verifyIsCnciDns());
        return UtilsUmsService.verifyIsCnciDns()? "assets/img/app/cfdi40General.png" : "assets/img/app/cfdi40.png";
    }

    public static getTheme() {
        return UtilsUmsService.verifyIsCnciDns()? 'navy-gold-light' : 'indigo-light';
    }

}
